<template>
  <v-layout column class="minergie">
    <div class="minergie-head">
      <div class="minergie-title">
        {{ 'oneclick.minergie.header' | translate }}
      </div>
    </div>
    <v-layout row align-end>
      <v-flex shrink>
        <form-field :text="'oneclick.minergie.objectId' | translate" class="form-field">
          <text-input
            :value="minergieUuid"
            :placeholder="'oneclick.minergie.objectId' | translate"
            :disabled="adminMinergieInfo.isLinked"
            @input="minergieUuid = $event"
          />
        </form-field>
      </v-flex>
      <v-flex shrink class="minergie-status">
        <popover class="infopopover" :color="infoPopoverColor" :icon="infoPopoverIcon" :header="'oneclick.minergie.header' | translate" :tooltip="infoPopoverText">
          {{ infoPopoverText }}
        </popover>
      </v-flex>
      <base-text-button class="minergie-button" v-if="!adminMinergieInfo.isLinked"
        @buttonClicked="linkAccountMinergie(minergieUuid.trim())"
        :enabled="!isInteracted" 
      > 
        {{ 'oneclick.minergie.link' | translate }}
      </base-text-button>
      <base-text-button class="minergie-button" v-if="adminMinergieInfo.isLinked"
        @buttonClicked="verifyAccountMinergie"
        :enabled="!isInteracted" 
      > 
        {{ 'oneclick.minergie.verify' | translate }}
      </base-text-button>
      <base-text-button class="minergie-button" v-if="adminMinergieInfo.isLinked"
        @buttonClicked="showConfirmUnlinkDialog = true"
        :enabled="!isInteracted" 
      > 
        {{ 'oneclick.minergie.unlink' | translate }}
      </base-text-button>
    </v-layout>
    <confirm-dialog 
      :show="showConfirmUnlinkDialog"
      :header="'oneclick.minergie.unlink' | translate"
      :text="'oneclick.minergie.unlink.confirmation' | translate"
      :cancel-button-text="'common.button.cancel' | translate"
      confirm-button-text="Ok"
      @confirmed="onUnlink"
      @cancelled="showConfirmUnlinkDialog = false"
    />
  </v-layout>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { MinergieConfigurationModel } from '../../../../../../eco-domain-store-modules/src/consumption/models'

const ConsumptionUi = namespace ('consumptionUi')
const Resource = namespace ('resource')

@Component({
  components: {
  },
})
export default class MinergieConfiguration extends Vue {
  @ConsumptionUi.Getter public isInteracted: boolean
  @ConsumptionUi.Getter public adminMinergieInfo: MinergieConfigurationModel
  @ConsumptionUi.Action public linkAccountMinergie: (minergieObjectId: string) => Promise<void>
  @ConsumptionUi.Action public unlinkAccountMinergie: () => Promise<void>
  @ConsumptionUi.Action public verifyAccountMinergie: () => Promise<void>
  @Resource.Getter public dictionary

  public showConfirmUnlinkDialog = false
  public minergieUuid = ''

  public mounted() {
    this.adminMinergieInfoChanged()
  }

  @Watch('adminMinergieInfo')
  public adminMinergieInfoChanged() {
    this.minergieUuid = this.adminMinergieInfo.minergieObjectId
  }

  public get infoPopoverColor() {
    if (this.adminMinergieInfo.isVerified) {
      return 'lime'
    } else if (this.adminMinergieInfo.isLinked) {
      return 'orange'
    } else {
      return 'yellow'
    }
  }

  public get infoPopoverIcon() {
    if (this.adminMinergieInfo.isVerified) {
      return 'check_circle'
    } else if (this.adminMinergieInfo.isLinked) {
      return 'check_circle'
    } else {
      return 'help'
    }
  }

  public get infoPopoverText() {
    if (this.adminMinergieInfo.isVerified) {
      return this.dictionary('oneclick.minergie.verified')
    } else if (this.adminMinergieInfo.isLinked) {
      return this.dictionary('oneclick.minergie.linked')
    } else {
      return this.dictionary('oneclick.minergie.unlinked')
    }
  }

  public onUnlink() {
    this.unlinkAccountMinergie()
    this.showConfirmUnlinkDialog = false
  }
}
</script>
<style lang="scss" scoped>
.minergie {
  margin-left: 30px;
  margin-bottom: 20px;
  .minergie-head {
    .minergie-title{
      font-size: 24px;
      line-height: 48px;
      height: 48px;
    }
  }
  .form-field {
    min-width: 300px;
    padding-right: 8px;
    margin-left: -10px;
    margin-bottom: 8px;
    div {
      margin-left: 10px;
    }
  }
  .minergie-status {
    margin-left: 10px;
    padding-bottom: 12px;
  }
  .v-btn {
    border: 1px solid white;
  }
}
</style>